import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import { Icon, IconArrowDown, IconArrowUp, IconDocuments } from '@flixbus/honeycomb-icons-react';

import { isProd } from 'utils/env';

import styles from './styles.module.css';

const DevPanel = ({ title, children }) => {
	const [isOpen, setIsOpen] = useState(false);

	if (isProd()) return null;

	const content = (
		<div className={styles.anchor}>
			{isOpen ? (
				<div className={styles.panel}>
					<button
						type="button"
						aria-label="Collapse dev panel"
						className={styles.header}
						onClick={() => setIsOpen(false)}
					>
						<Icon InlineIcon={IconDocuments} />
						<span className={styles.title}>{title}</span>
						<Icon InlineIcon={IconArrowDown} />
					</button>
					<div className={styles.body}>{children}</div>
				</div>
			) : (
				<button
					type="button"
					aria-label="Open dev panel"
					className={styles.trigger}
					onClick={() => setIsOpen(true)}
				>
					<Icon InlineIcon={IconArrowUp} />
				</button>
			)}
		</div>
	);

	return createPortal(content, document.body);
};

export default DevPanel;
